import { ref } from 'vue'
import { route } from '~@/Composables/route'

export function getCountries () {
    const isLoading = ref(true)
    const countries = ref([])

    window.axios.get(route('settings.countries.dropdown'))
        .then(response => {
            countries.value = response.data
            isLoading.value = false
        })

    return { isLoading, countries }
}
